// extracted by mini-css-extract-plugin
export default {"content":"NameCardButton_content__ibnur","col":"NameCardButton_col__h-REw","button":"NameCardButton_button__OxGWl"};